import React, { useMemo } from 'react'
import {
    Box,
    TextField,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Alert,
    FormControl,
} from '@mui/material'

import { faAngleDown } from '@fortawesome/pro-duotone-svg-icons/faAngleDown'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import LocaleName from '../../../../../Components/Elements/Translations/LocaleName'
import { FormInputLabel } from '@/Components/Elements/StyledComponents/Input'
import { BlockFormState } from '../../types'

interface TranslationsTabProps {
    kedo: any
    state: BlockFormState
    onChangeTranslation: (locale: string, title: string) => void
}

const TranslationsTab: React.FC<TranslationsTabProps> = ({
    kedo,
    state,
    onChangeTranslation,
}) => {
    const renderTranslations = useMemo(() => {
        const locales: any = kedo.env().getEnvironmentLocales()
        if (!locales)
            return <Alert severity="info">{kedo.t('No languages set')}</Alert>

        if (locales.length === 1) {
            const locale = locales[0]
            const trans: any =
                state.item.translations.find(
                    (item) => locale.code === item.culture
                ) || {}
            return (
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>{kedo.t('Name')}</FormInputLabel>
                    <TextField
                        fullWidth
                        value={trans.title || ''}
                        onChange={(event) =>
                            onChangeTranslation(locale.code, event.target.value)
                        }
                        size="small"
                    />
                </FormControl>
            )
        }

        return (
            <Box sx={{ mt: 2 }}>
                {locales.map(
                    (locale: {
                        code: string
                        id: React.Key | null | undefined
                    }) => {
                        const trans: any =
                            state.item.translations.find(
                                (item) => locale.code === item.culture
                            ) || {}
                        return (
                            <Accordion
                                key={locale.id}
                                defaultExpanded={locale.id === locales[0].id}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <FontAwesomeIcon icon={faAngleDown} />
                                    }
                                >
                                    <LocaleName
                                        kedo={kedo}
                                        localeCode={locale.code}
                                    />
                                </AccordionSummary>
                                <AccordionDetails>
                                    <TextField
                                        fullWidth
                                        value={trans.title || ''}
                                        type="text"
                                        onChange={(event) =>
                                            onChangeTranslation(
                                                locale.code,
                                                event.target.value
                                            )
                                        }
                                        size="small"
                                    />
                                </AccordionDetails>
                            </Accordion>
                        )
                    }
                )}
            </Box>
        )
    }, [state.item.translations, kedo, onChangeTranslation])

    return renderTranslations
}

export default TranslationsTab
